import {
  Client,
  fetchExchange,
  cacheExchange as defaultCacheExchange,
} from "urql";
import { mapExchange } from "@urql/core";
import { authExchange } from "@urql/exchange-auth";
import type { introspection } from "../graphql-env";
import type { initGraphQLTada } from "gql.tada";
import { transformAllLabelsInObject } from "./transformAllLabelsInObject";

export const generateContentfulClient = (
  url: string,
  headers: Record<string, string> = {}
) =>
  new Client({
    url,
    exchanges: [
      mapExchange({
        onResult(result) {
          return {
            ...result,
            data: transformAllLabelsInObject(result.data),
          };
        },
      }),
      defaultCacheExchange,
      authExchange(async (utils) => ({
        addAuthToOperation(operation) {
          return utils.appendHeaders(operation, headers);
        },
        didAuthError(error) {
          const networkErrorMsg = error.networkError?.message;
          const didError =
            error.graphQLErrors.some(
              (e) => e.extensions?.code === "FORBIDDEN"
            ) || !!networkErrorMsg;

          if (networkErrorMsg) console.error(networkErrorMsg);

          return didError;
        },
        async refreshAuth() {
          throw new Error("No auth refresh operation");
        },
      })),
      fetchExchange,
    ],
  });

declare module "gql.tada" {
  //@ts-expect-error This isn't actually overriding anything.
  // This change just ensures that DateTime comes back,
  // accurately, as a string without having to utilize a
  // "custom" graphql function.
  declare const graphql: ReturnType<
    typeof initGraphQLTada<{
      introspection: introspection;
      scalars: { DateTime: string };
    }>
  >;
}
